import { emReais } from './basicos.jsx'

/**
 * Comparativo de custo por km entre veículos: barras em HTML puro, sem biblioteca
 * de gráficos — assim o dashboard e o formulário de lançamento não carregam o
 * Recharts, que só a tela de estatísticas precisa.
 *
 * Cada barra traz nome e valor como rótulo direto, então a leitura não depende da
 * cor (as barras claras ficam abaixo de 3:1 de contraste, e é esse rótulo que as
 * torna legíveis mesmo assim).
 */
export function ComparativoVeiculos({ itens }) {
  if (!itens?.length) return null
  const maior = Math.max(...itens.map((i) => i.custo_total_por_km))

  return (
    <div className="pilha" style={{ gap: 10 }}>
      {itens.map((item, indice) => (
        <div key={item.veiculo_id} className="pilha" style={{ gap: 4 }}>
          <div className="entre">
            <span style={{ fontSize: '0.85rem' }}>{item.nome}</span>
            <strong style={{ fontVariantNumeric: 'tabular-nums' }}>
              {emReais(item.custo_total_por_km)}/km
            </strong>
          </div>
          <div style={{ background: 'var(--superficie-2)', borderRadius: 4, height: 10 }}>
            <div
              style={{
                width: `${Math.max(4, (item.custo_total_por_km / maior) * 100)}%`,
                height: '100%',
                borderRadius: 4,
                background: `var(--serie-${(indice % 6) + 1})`,
              }}
            />
          </div>
        </div>
      ))}
    </div>
  )
}
